

import React from 'react';
import { getConfiguration } from '../../config';
import getStyle from './style';
import { Div } from '../../primitives';

// $FlowFixMe
export const GutterWidthContext = React.createContext(false);













const Row = ({
  children,
  style,
  align = 'normal',
  justify = 'start',
  direction = 'row',
  nogutter = false,
  gutterWidth = null,
  debug = false,
  component = Div,
  nowrap = false,
  ...otherProps
}) => {
  let theGutterWidth = getConfiguration().gutterWidth;
  if (nogutter) theGutterWidth = 0;
  if (typeof gutterWidth === 'number') theGutterWidth = gutterWidth;

  const theStyle = getStyle({
    gutterWidth: theGutterWidth,
    align,
    justify,
    debug,
    moreStyle: style,
    nowrap,
    direction
  });
  return React.createElement(
    component,
    { style: theStyle, ...otherProps },
    <GutterWidthContext.Provider value={theGutterWidth}>
      {children}
    </GutterWidthContext.Provider>
  );
};

export default Row;